<template>
  <div class="mt-4 px-3">
    <div class="row">
      <div class="table-responsive">
        <table class="table table-striped table-bordered">
          <thead class="cusmtom-thead-color">
            <tr class="cusmtom-thead-color">
              <th class="text-center p-3 custom-header-label" rowspan="2">
                {{ $t('sigatoka.plant') }}
              </th>
              <th class="text-center p-3 custom-header-label" rowspan="2">
                {{ $t('sigatoka.total_functional_leaves') }}
              </th>
              <th class="text-center p-3 custom-header-label" rowspan="2">
                {{ $t('sigatoka.yls') }}
              </th>
              <th
                v-if="age == 0 || age == 6"
                class="text-center p-3 custom-header-label"
                rowspan="2"
              >
                {{ $t('sigatoka.yli') }}
              </th>
              <th
                class="text-center p-3 custom-header-label"
                rowspan="1"
                colspan="5"
                v-if="infectionPicture"
              >
                {{ $t('sigatoka.infection_picture') }}
              </th>
              <th class="text-center p-3 custom-header-label" rowspan="2">
                {{ $t('common_words.options') }}
              </th>
            </tr>
            <tr v-if="infectionPicture">
              <th class="text-center p-3 custom-header-label" rowspan="1">0</th>
              <th class="text-center p-3 custom-header-label" rowspan="1">1</th>
              <th class="text-center p-3 custom-header-label" rowspan="1">2</th>
              <th class="text-center p-3 custom-header-label" rowspan="1">3</th>
              <th class="text-center p-3 custom-header-label" rowspan="1">4</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(plant, index) in plants"
              :key="plant.id || `new-${index}`"
              v-if="!plant.deleted"
            >
              <td class="col-12 col-md-1 col-lg-1 col-xl-1 p-0">
                <fg-input
                  class="m-3"
                  type="number"
                  v-model="plant.number"
                  @keypress="validateInput"
                ></fg-input>
              </td>
              <td class="col-12 col-md-2 col-lg-2 col-xl-2 p-0">
                <fg-input
                  class="m-3"
                  type="number"
                  v-model="plant.total_leaves"
                  @input="limitInput(plant, 'total_leaves')"
                  @keypress="validateInput"
                ></fg-input>
              </td>
              <td class="col-12 col-md-2 col-lg-2 col-xl-2 p-0">
                <fg-input
                  class="m-3"
                  type="number"
                  v-model="plant.yls"
                  @input="limitInput(plant, 'yls')"
                  @keypress="validateInput"
                ></fg-input>
              </td>
              <td
                class="col-12 col-md-2 col-lg-2 col-xl-2 p-0"
                v-if="age == 0 || age == 6"
              >
                <fg-input
                  class="m-3"
                  type="number"
                  v-model="plant.yli"
                  @input="limitInput(plant, 'yli')"
                  @keypress="validateInput"
                ></fg-input>
              </td>
              <td
                class="col-12 col-md-1 col-lg-1 col-xl-1 p-0"
                v-if="infectionPicture"
              >
                <fg-input
                  disabled
                  class="m-3"
                  type="number"
                  :value="calculateGradeZero(plant)"
                  @keypress="validateInput"
                ></fg-input>
              </td>
              <td
                class="col-12 col-md-1 col-lg-1 col-xl-1 p-0"
                v-if="infectionPicture"
              >
                <fg-input
                  class="m-3"
                  type="number"
                  v-model="plant.grades[1]"
                  @input="limitGradeInputs(plant, 'one')"
                  @keypress="validateInput"
                ></fg-input>
              </td>
              <td
                class="col-12 col-md-1 col-lg-1 col-xl-1 p-0"
                v-if="infectionPicture"
              >
                <fg-input
                  class="m-3"
                  type="number"
                  v-model="plant.grades[2]"
                  @input="limitGradeInputs(plant, 'two')"
                  @keypress="validateInput"
                ></fg-input>
              </td>
              <td
                class="col-12 col-md-1 col-lg-1 col-xl-1 p-0"
                v-if="infectionPicture"
              >
                <fg-input
                  class="m-3"
                  type="number"
                  v-model="plant.grades[3]"
                  @input="limitGradeInputs(plant, 'three')"
                  @keypress="validateInput"
                ></fg-input>
              </td>
              <td
                class="col-12 col-md-1 col-lg-1 col-xl-1 p-0"
                v-if="infectionPicture"
              >
                <fg-input
                  class="m-3"
                  type="number"
                  v-model="plant.grades[4]"
                  @input="limitGradeInputs(plant, 'four')"
                  @keypress="validateInput"
                ></fg-input>
              </td>
              <td
                class="text-center custom-td-pd col-12 col-md-2 col-lg-2 col-xl-2 p-0"
                style="min-width: 120px"
              >
                <div class="d-flex justify-content-center m-3">
                  <a
                    v-if="isUpdate()"
                    v-tooltip.top-center="$t('common_words.add')"
                    class="btn-warning btn-simple btn-link custom-margin-actions"
                    @click.prevent="addRow()"
                  >
                    <em class="fa fa-plus custom-size-fa-actions"></em>
                  </a>
                  <a
                    v-if="isDelete() && activePlantsCount > 0"
                    v-tooltip.top-center="$t('common_words.erase')"
                    class="btn-danger btn-simple btn-link custom-margin-actions"
                    @click="removeRow(index)"
                  >
                    <em class="fa fa-times custom-size-fa-actions"></em>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import MixinMenu from 'src/util/mixinMenu';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';

export default {
  name: 'age-table',
  mixins: [MixinMasters, MixinPermissions, MixinForm, MixinMenu],
  props: {
    age: {
      type: Number,
      required: true,
    },
    changeLabel: {
      type: Boolean,
      required: true,
      default: false,
    },
    infectionPicture: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      plants: [],
    };
  },
  computed: {
    activePlantsCount() {
      return this.plants.filter((plant) => !plant.deleted).length;
    },
  },
  methods: {
    createPlant(number) {
      return {
        id: null,
        age: this.age,
        total_leaves: null,
        yls: null,
        yli: null,
        number,
        grades: this.createGradeValues(),
        deleted: false,
      };
    },
    createGradeValues() {
      return {
        0: null,
        1: null,
        2: null,
        3: null,
        4: null,
      };
    },
    calculateGradeZero(plant) {
      const totalLeaves = Number(plant.total_leaves) || 0;
      const otherGrades =
        (Number(plant.grades[1]) || 0) +
        (Number(plant.grades[2]) || 0) +
        (Number(plant.grades[3]) || 0) +
        (Number(plant.grades[4]) || 0);

      return totalLeaves - otherGrades;
    },
    addRow() {
      const activePlants = this.plants.filter((plant) => !plant.deleted);
      const lastNumber =
        activePlants.length > 0
          ? Math.max(...activePlants.map((item) => Number(item.number) || 0))
          : 0;
      this.plants.push(this.createPlant(lastNumber + 1));
    },
    removeRow(index) {
      const plant = this.plants[index];
      if (plant.id) this.$set(plant, 'deleted', true);
      else this.plants.splice(index, 1);
      const activePlants = this.plants.filter((item) => !item.deleted);
      if (activePlants.length === 0) this.plants.push(this.createPlant(1));
    },
    getData() {
      return this.plants.map((plant) => ({
        ...plant,
        age: this.age,
        grades: {
          ...plant.grades,
          0: this.calculateGradeZero(plant),
        },
      }));
    },
    setData(plants) {
      if (!plants || !plants.length) {
        this.resetData();
        return;
      }

      this.plants = plants.map((plant) => {
        const gradeValues = this.createGradeValues();
        if (
          this.infectionPicture &&
          plant.sigatoka_infections &&
          plant.sigatoka_infections.length
        )
          plant.sigatoka_infections.forEach((infection) => {
            const grade = Number(infection.grade);

            gradeValues[grade] = infection.infected_leaves;
          });

        return {
          id: plant.id,
          number: plant.plant,
          total_leaves: plant.functional_leaf,
          yls: plant.yls,
          yli: plant.yli,
          grades: gradeValues,
          deleted: false,
        };
      });
    },
    resetData() {
      this.plants = [this.createPlant(1)];
    },
    validateInput(event) {
      const input = String.fromCharCode(event.which);
      if (!/[0-9,.]/.test(input)) event.preventDefault();
    },
    limitInput(object, field) {
      const value = Number(object[field]);
      if (value > 30) object[field] = 30;
    },
    limitGradeInputs(plant, grade) {
      const value = Number(plant.grades[grade]);
      if (value > 30) plant.grades[grade] = 30;
    },
  },
  created() {
    this.plants.push(this.createPlant(1));
  },
};
</script>
<style scoped>
.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}

.custom-td-pd {
  padding: 0px !important;
}

.table-responsive {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: 80vh;
}

.cusmtom-thead-color {
  position: sticky;
  top: 0;
  z-index: 2;
}
</style>
